var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"primary-nav",style:({ backgroundColor: _vm.siteColour })},[_c('ol',_vm._l((_vm.links),function(l,index){return _c('NavLink',{key:index,attrs:{"href":l.href,"observe":l.observe,"text":l.text}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }